import React from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import Image from "next/image";
import { AppSize, IMedia, IProperties, pxToRem } from "@/util";
import PortfolioCard from "@/components/property/portfolioSlide";
import Overview from "@/components/property/overview";
import Mapcard from "@/components/property/mapCard";
import { facilities } from "@/util/data/propertyData";
import { AppColors } from "@/assets/colors";
import Facdoc from "@/components/property/facdoc";
type props = {
  data: Partial<IProperties>;
};
export default function OnePortfolio({ data }: Partial<props>) {
  const { classes } = styles();
  return (
    <Box className={`${classes.container}`}>
      <Box>
        <Box className={classes.card}>
          <PortfolioCard
            media={data?.media?.slice(0, 3) as Partial<IMedia>[]}
          />
        </Box>
        <Overview data={data && data} />
        <Box className={classes.map}>
          <Mapcard data={data} />
          <Facdoc
            icon={"/images/overview/tick-circle.svg"}
            data={data?.facilities as unknown as typeof facilities}
            head="Facilities"
            color={AppColors.text.default}
          />
        </Box>
        <Box className={classes.show}>
          {data?.media?.map((value: Partial<IMedia>, key) => {
            return (
              <Box className={classes.imgShow} key={key}>
                <Image
                  src={value?.url || ""}
                  fill
                  objectFit="cover"
                  alt="globe"
                />
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: pxToRem(500),
    padding: `0px ${pxToRem(AppSize.padding)}`,
    marginTop: theme.spacing(3),
    gap: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: `0px
      ${pxToRem(20)}`,
      marginTop: theme.spacing(3),
      gap: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
  },
  show: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: theme.spacing(3),
    position: "relative",
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  imgShow: {
    position: "relative",
    height: pxToRem(276),
    borderRadius: pxToRem(8),
    overflow: "hidden",
  },
  card: {
    margin: `${pxToRem(AppSize.padding)} 0px`,
    width: "auto",
    [theme.breakpoints.down("sm")]: {
      margin: `${pxToRem(20)} 0px`,
    },
  },
  head: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  name: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(30),
  },
  map: {
    minHeight: pxToRem(463),
    display: "grid",
    gridTemplateColumns: "3fr 1.5fr",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(3),
      marginTop: theme.spacing(4),
    },
  },
}));
